import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const StyWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${SPACING._12};
`;

export const StyFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;
